import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource,PageEvent } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { AutoWithdrawService } from "../services/autowithdraw.service";
import { AddAutoWithdrawal } from './addautowithdrawal/addautowithdrawal.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { NotificationsService } from 'angular2-notifications';
const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}
@Component({
    selector: 'app-autowithdrawal',
    templateUrl: './autowithdrawal.component.html',
    styleUrls: ['./autowithdrawal.component.css']
})
export class AutoWithdrawalComponent implements OnInit {
    displayedColumns = [
        'Action',
        'user_name',
        'admin_name',
        'currency',
        'quantity_to_send',
        'quantity_transfered',
        'min_transfer_quantity',
        'disable',
        'rate',
        'address',
        'assetid',
        'blockchain',
        'status',
        'note',
        'createdAt'
    ];
    displayedColumnsTransactions = [
        'txnid', 
        'status',
        'currency', 
        'amount', 
        'txHash', 
        'fireblock_status', 
        'fireblock_sub_status', 
        'note', 
        'createdAt', 
    ];
    fromDate;
    toDate;
    filter: any = {};
    isTransactionsId: any;
    autoWithdrawId:any;
    
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    public autoWithdrawDataSource: any = new MatTableDataSource();
    public autoWithdrawTransactionsDataSource: any = new MatTableDataSource();
    pageSize = 10;
    pageSize1 = 10;
    currentPage = 0;
    currentPage1 = 0;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator1: MatPaginator;
    @ViewChild(MatSort) sort1: MatSort;
    constructor(
        private userService: UserService,
        private notifSer: NotificationsService,
        private autoWithdrawService: AutoWithdrawService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    async pageChanged(event: PageEvent) {
        this.pageSize = await event.pageSize;
        this.currentPage = await event.pageIndex;
    }
    async pageChanged1(event: PageEvent) {
        this.pageSize1 = await event.pageSize;
        this.currentPage1 = await event.pageIndex;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.autoWithdrawDataSource.filter = filterValue;
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.autoWithdrawService.getAutoWithdraw(this.filter).subscribe((success) => {
                let autoWithdrawRes = success.map(autoWithdraw => {
                    autoWithdraw.createdAt = moment(autoWithdraw.createdAt).format('MM/DD/YY h:mm:ss A');
                    if (autoWithdraw.userid && autoWithdraw.userid.name) {
                        autoWithdraw.user_name = autoWithdraw.userid.name;
                    }
                    if (autoWithdraw.adminid && autoWithdraw.adminid.name) {
                        autoWithdraw.admin_name = autoWithdraw.adminid.name;
                    }
                    return autoWithdraw;
                })
                this.autoWithdrawDataSource = new MatTableDataSource(autoWithdrawRes);
                this.autoWithdrawDataSource.paginator = this.paginator
                this.autoWithdrawDataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.autoWithdrawDataSource.filteredData) {
            const autoWithdraw = await this.autoWithdrawDataSource.filteredData.map(x => ({
                'User': x.user,
                'Currency': x.currency,
                'Quantity to send': x.quantity_to_send,
                'Quantity transfered': x.quantity_transfered,
                'Min transfered': x.min_transfer_quantity,
                'Rate': x.rate,
                'Address': x.address,
                'Asset Id': x.assetid,
                'Blockcha Id': x.blockchain,
                'Status': x.status,
                'Note': x.note,
                'Disable': x.disable,
                'Created At': x.createdAt,
            }));
            TableUtil.exportArrayToExcel(autoWithdraw, "auto-withdraw");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
    addAutoWithdrawal = async () => {
        try {
            var new_element = {
            }
            this.dialog.open(AddAutoWithdrawal, {
                width: '600px',
                data: new_element,
            }).afterClosed().subscribe(result => {
                if (result && result.success) {
                    this.applyRefreshData();
                }
            });
        } catch (error) {
            console.log(error);
        }
    }

    updateAutoWithdrawal(event: any, element: any, key: any) {
        element[key] = event;
        this.dialog.open(ConfirmationDialogComponent, {
            data: {
                message: 'Are you sure want to confirm?',
                buttonText: {
                    ok: 'Yes',
                    cancel: 'Cancel'
                }
            }
        }).afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                const { notif } = defaults;
                this.userService.csrf().subscribe(user => {
                    var formObj = {};
                    formObj['_id'] = element._id;
                    formObj['_csrf'] = user._csrf;
                    formObj['key'] = key;
                    formObj['value'] = event;
                    this.autoWithdrawService.updateAutoWithdrawToggle(formObj).subscribe((response) => {
                        this.notifSer.success(
                            'Success',
                            response.message, notif
                        )
                    }, (err) => {
                        element[key] = !event
                        this.notifSer.error(
                            'Error',
                            err.message, notif
                        )
                    })
                });
            }else{
                element[key] = !event
            }
        });
    }
    getAutoWithdrawTransactions(autoWithdrawId: any, userId: any) {
        this.autoWithdrawId = autoWithdrawId;
        this.isTransactionsId = true;
        var formObj = {};
        formObj['_csrf'] = this.filter._csrf;
        formObj['autoWithdrawId'] = autoWithdrawId;
        this.autoWithdrawService.getAutoWithdrawTransactions(formObj).subscribe(data => {
            let autoWithdrawTransactionsRes = data.map(autoWithdrawTransactions => {
                autoWithdrawTransactions.createdAt = moment(autoWithdrawTransactions.createdAt).format('MM/DD/YY h:mm:ss A');
                return autoWithdrawTransactions;
            })
            if (autoWithdrawTransactionsRes) {
                this.autoWithdrawTransactionsDataSource = new MatTableDataSource(autoWithdrawTransactionsRes);
                this.autoWithdrawTransactionsDataSource.paginator = this.paginator1;
                this.autoWithdrawTransactionsDataSource.sort = this.sort1;
            }
        })
    }
    
}


// WEBPACK FOOTER //
// ./src/app/autowithdrawal/autowithdrawal.component.ts